import { Component, OnInit } from '@angular/core';
import PerfectScrollbar from 'perfect-scrollbar';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { User } from 'models/user';
import { CryptService } from 'services/crypt/crypt.service';

declare const $: any;

//Metadata
export interface RouteInfo {
    id: string;
    path: string;
    title: string;
    type: string;
    icontype: string;
    collapse?: string;
    children?: ChildrenItems[];
    ng_if: boolean;
}

export interface ChildrenItems {
    path: string;
    title: string;
    ab: string;
    type?: string;
}
//Menu Items---
export const ROUTES: RouteInfo[] = [
    // {
    //     id: 'dashboard',
    //     path: '/dashboard',
    //     title: 'Dashboard',
    //     type: 'link',
    //     icontype: 'dashboard'
    // }, 

    {
        id: 'vote',
        path: '/elections/vote',
        title: 'Votar',
        type: 'link',
        icontype: 'how_to_vote',
        ng_if: false
    },

    {
        id: 'student',
        path: '/student',
        title: 'Estudiante',
        type: 'sub',
        icontype: 'school',
        collapse: 'estudiante',
        ng_if: false,
        children: [

            { path: 'create_student', title: 'Actualizar información', ab: 'RE' },
            { path: 'invoces', title: 'Facturas del estudiante', ab: 'FE' },
            { path: 'boletin', title: 'Ver boletín', ab: 'VB' },
            // { path: 'transporte', title: 'Afiliacion a transporte', ab: 'AT' }
        ]
    },
    {
        id: 'notes',
        path: '/notes',
        title: 'Notas',
        type: 'sub',
        icontype: 'notes',
        collapse: 'notas',
        ng_if: false,
        children: [
            { path: 'logros', title: 'Logros', ab: 'L' },
            { path: 'ver-notas', title: 'Ver Notas', ab: 'VN' },
        ]
    },
    // {
    //     id: 'bills',
    //     path: '/bills',
    //     title: 'Cuentas',
    //     type: 'sub',
    //     icontype: 'monetization_on',
    //     collapse: 'cuentas',
    //     children: [

    //         { path: 'checkbills', title: 'Consultar Cuentas', ab: 'CC' },
    //         { path: 'transfer', title: 'Transferencia', ab: 'TR' },

    //     ]
    // },
    // {
    //     id: 'egress',
    //     path: '/egress',
    //     title: 'Egresos',
    //     type: 'sub',
    //     icontype: 'arrow_downward',
    //     collapse: 'egresos',
    //     children: [

    //         { path: 'create_egress', title: 'Crear egreso', ab: 'CRE' },
    //         { path: 'check_egress', title: 'Consultar egresos', ab: 'CNE' },

    //     ]
    // },
    // {
    //     id: 'third',
    //     path: '/third',
    //     title: 'Terceros',
    //     type: 'sub',
    //     icontype: 'group',
    //     collapse: 'terceros',
    //     children: [

    //         { path: 'createthird', title: 'Crear Terceros', ab: 'CRT' },
    //         { path: 'checkthird', title: 'Consultar Terceros', ab: 'CNT' },

    //     ]
    // },
];

@Component({
    selector: 'app-sidebar-cmp',
    templateUrl: 'sidebar.component.html',
})

export class SidebarComponent implements OnInit {

    userName: string;
    userRole: string;
    urlImage: any = "";


    constructor(private router: Router, public crypt: CryptService, ) {

        $(document).ready(() => {

            $('.sidebar').mouseenter(function () {
                $(".main-content").addClass("contentb")
            })

            $('.sidebar').mouseleave(function () {
                $(".main-content").removeClass("contentb")
            })

        });

        this.userName = localStorage.getItem("userName");
    }

    public menuItems: any[];

    goHome() {
        // this.router.navigate(['pages/login']);
    }

    isMobileMenu() {
        if ($(window).width() > 991) {
            return false;
        }
        return true;
    };

    async ngOnInit() {

        // localStorage.getItem("userRole") == 'Alumno'

        // this.userRole = localStorage.getItem("userRole");

        this.menuItems = ROUTES.filter(menuItem => menuItem);

        if (localStorage.getItem("session") == "1") {
            await this.valideRole();
        }

        // if (localStorage.getItem("vote") === "1") {
        //     $(() => {
        //         $("#student.nav-item").remove()
        //     })
        // } else {
        //     $(() => {
        //         $("#vote.nav-item").remove()
        //     })
        // }

        // if (this.userRole === "SUPERVISOR") {

        //     this.menuItems.forEach((value) => {

        //         $(document).ready(() => {

        //             if (value.id === 'inventory' || value.id === 'human_resources' || value.id === 'sales') {
        //                 //console.log("show")
        //             } else {

        //                 $("#" + value.id + "").remove();

        //             }

        //         })

        //     });

        // }


    }
    updatePS(): void {
        // if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
        //     const elemSidebar = <HTMLElement>document.querySelector('.sidebar .sidebar-wrapper');
        //     let ps = new PerfectScrollbar(elemSidebar, { wheelSpeed: 2, suppressScrollX: true });
        // }
    }
    isMac(): boolean {
        let bool = false;
        if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
            bool = true;
        }
        return bool;
    }

    close() {
        $(document).ready(function () {
            $('#transport_button').click();
            $('#contt').animate({ scrollTop: 0 }, 300);
        });

        setTimeout(() => {

            this.router.navigate(['pages/login']);
            localStorage.setItem('session', '0');
            window.localStorage.clear();
        }, 500);
    }

    unblind() {

        //    $('.sidebar').css( ':normal  ' );

    }

    public async valideRole() {
        this.urlImage = null;
        if (document.getElementById("userImage")) {
            document.getElementById("userImage").remove();
        }

        if (document.getElementById("iconImage")) {
            document.getElementById("iconImage").remove();
        }
        const eA23 = localStorage.getItem("eA23")
        const eA21 = localStorage.getItem("eA21")

        let decrypted = await this.crypt.decrypt(eA23);
        // let decrypted1 = JSON.parse(await this.crypt.decrypt(eA21));
        // console.log(decrypted1);

        if (localStorage.getItem('urlImage')) {
            let imageurl = localStorage.getItem('urlImage');
            if (imageurl != null) {
                this.urlImage = imageurl;
            }
        }

        // console.log(this.urlImage);
        if (this.urlImage) {

            setTimeout(() => {
                document.getElementById("icondiv").innerHTML =
                    `<img id="userImage" onclick="viewImage()" src="" style="position: absolute;
                    width: 45px;
                    height: 60px;"/>`
                let profile = document.getElementById("userImage")
                profile.setAttribute("src", this.urlImage + `?${performance.now()}`);
                // profile.style.background = `url(${this.urlImage})`
                // profile.style.backgroundPosition = 'center'
                // profile.style.backgroundRepeat = 'no-repeat'
                // profile.style.backgroundSize = 'cover'
            }, 1000);
        } else {


            setTimeout(() => {
                document.getElementById("icondiv").innerHTML =
                    `<i id="iconImage" class="material-icons" style="font-size: 53px;
                    left: -4px;
                    position: relative;
                    top: -4px;">account_circle</i>`
            }, 1000);
        }

        // console.log(decrypted);
        // console.log(ROUTES);
        // valido si no existe la variable de norenovacion para evitar que al
        // borrarla del localStorage puedan realizar la renovacion sin permiso
        if (localStorage.getItem("eA24")) {
            if (localStorage.getItem("vote") == "1" && decrypted == "Alumno") {
                ROUTES[0].ng_if = true;
            } else {
                ROUTES[0].ng_if = false;
            }

            if (localStorage.getItem("vote") == "0" && decrypted == "Alumno") {
                ROUTES[1].ng_if = true;
            } else {
                ROUTES[1].ng_if = false;
            }

            if (decrypted == "Administrador") {
                ROUTES[2].ng_if = true;
            } else {
                ROUTES[2].ng_if = false;
            }
        } else {
            ROUTES[0].ng_if = false;
            ROUTES[1].ng_if = false;
            ROUTES[2].ng_if = false;
        }

        this.menuItems = ROUTES.filter(menuItem => menuItem);
        return;
    }
}
